<template>
    <div class="fluid">
        <h1 class="app-title">CANCELAMENTO DE TRP</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                    <b-button
                            id="btnCancelar"
                            class="ml-2"
                            v-b-modal.modal-cancelar
                            variant="primary"
                            style="height: 40px;"
                            :disabled="selecteds.length <= 0">
                        <i class="fas fa-trash"></i> Cancelar o TRP
                    </b-button>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col class="text-right">
                    <b-button class="ml-2 my-2" variant="outline-secondary" @click="exportarConsulta"
                              style="height: 40px; padding: 0 0.75rem;">
                        <i class="fas fa-print"></i> Imprimir
                    </b-button>
                    <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros"
                              style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="col-2" style="height: 40px;"></b-form-select>
                </b-col>
            </b-row>
            <TabelaCancelarTrp
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>TRP(s) Encontradas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>TRP(s) Selecionadas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
            ref="modal-cancelar"
            id="modal-cancelar"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="Cancelar a TRP"
            header-bg-variant="info"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja realmente cancelar a(s) TRP(s) selecionada(s)?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar')"> Não</b-button>
                <b-button variant="primary" @click="cancelar"> Sim</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaCancelarTrp from "./TabelaCancelarTrp";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaCancelarTrp, Multiselect, CompLoading},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                value: null,
                options: [
                    {name: 'ICMS', code: 'av'},
                    {name: 'ITCMD', code: 'pa'}
                ],
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'dossie.datahorainclusao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    numero: null,
                    processo: null,
                    cda: null,
                    devedor: null,
                    filtrarDevedor: null,
                    emissao: null,
                    filtrarEmissao: null,
                    usuario: null,
                    filtrarUsuario: null,
                    situacao: null,
                }
            }
        },
        methods: {
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/cancelarTrp/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'cancelarTrp';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'TRP') {
                        this.filtro.campoMascara = this.filtros.numero;
                    } else if(this.filtro.campoFiltro == 'Processo') {
                        this.filtro.campoMascara = this.filtros.processo;
                    } else if(this.filtro.campoFiltro == 'Cda') {
                        this.filtro.campoMascara = this.filtros.cda;
                    } else if(this.filtro.campoFiltro == 'Devedor') {
                        this.filtro.filtrarEm = this.filtros.filtrarDevedor;
                        this.filtro.campoTexto = this.filtros.devedor;
                    } else if(this.filtro.campoFiltro == 'Data de Emissão') {
                        this.filtro.filtrarEm = this.filtros.filtrarEmissao;
                        this.filtro.campoData = this.filtros.emissao;
                    } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                        this.filtro.filtrarEm = this.filtros.filtrarUsuario;
                        this.filtro.campoTexto = this.filtros.usuario;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoCheckbox = this.filtros.situacao;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'TRP') {
                    this.filtros.numero = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Processo') {
                    this.filtros.processo = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Cda') {
                    this.filtros.cda = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.filtros.filtrarDevedor = this.filtro.filtrarEm;
                    this.filtros.devedor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data de Emissão') {
                    this.filtros.filtrarEmissao = this.filtro.filtrarEm;
                    this.filtros.emissao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                    this.filtros.filtrarUsuario = this.filtro.filtrarEm;
                    this.filtros.usuario = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoCheckbox;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'TRP') {
                    this.configTable.sortField = 'dossie.coddossietrp';
                } else if(this.filtro.campoFiltro == 'Processo') {
                    this.configTable.sortField = 'dossieCda.numerounico';
                } else if(this.filtro.campoFiltro == 'Cda') {
                    this.configTable.sortField = 'dossieCda.numerodivida';
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.configTable.sortField = 'contribuinte.nome';
                } else if(this.filtro.campoFiltro == 'Data de Emissão') {
                    this.configTable.sortField = 'dossie.datahorainclusao';
                } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                    this.configTable.sortField = 'usuario.nome';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'situacao';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },

            limparFiltros() {
                this.filtros = {
                    numero: null,
                    processo: null,
                    cda: null,
                    devedor: null,
                    filtrarDevedor: null,
                    emissao: null,
                    filtrarEmissao: null,
                    usuario: null,
                    filtrarUsuario: null,
                    situacao: null,
                };

                this.consultar();
            },

            cancelar() {
                this.hideModal('modal-cancelar')
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/cancelarTrp/cancelar`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                    this.selecteds = [];
                    this.$refs.loading.hideLoading();
                    this.consultar();
                }).catch((error) => {
                    this.exibirErro(error)
                    this.$refs.loading.hideLoading();
                });
            },

            async exportarConsulta() {
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/cancelarTrp/exportar?page=${this.configTable.currentPage}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'CancelarTrpConsulta.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            onScroll(e) {
                var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement;
                var commandLine = document.getElementById("btnCancelar").parentElement.parentElement;

                commandLine.style.position = 'sticky';
                commandLine.style.top = '60px';
                commandLine.style.zIndex = 2;
                commandLine.classList.add("background-scroller");

                thColunas.style.position = 'sticky';
                thColunas.style.top = (59 + commandLine.offsetHeight) + 'px';
                thColunas.style.zIndex = 1;
            },
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            this.obterColunasUsuario();
            this.consultar();

            window.addEventListener("scroll", this.onScroll);
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.onScroll)
        },
    }
</script>
